(function () {
  function initTabbedMegaMenu(menu) {
    var tabs = menu.querySelectorAll('[data-tp-tab]');
    var panels = menu.querySelectorAll('[data-tp-panel]');

    if (!tabs.length || !panels.length) return;

    function activateTab(index) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-tp-tab') === String(index);
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-tp-panel') === String(index);
        panel.classList.toggle('is-active', isActive);
      });
    }

    tabs.forEach(function (tab) {
      var index = tab.getAttribute('data-tp-tab');

      tab.addEventListener('mouseenter', function () {
        activateTab(index);
      });

      tab.addEventListener('focus', function () {
        activateTab(index);
      });

      tab.addEventListener('click', function () {
        activateTab(index);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tp-mega]').forEach(initTabbedMegaMenu);
  });
})();